import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, Subject } from 'rxjs';
import { ClienteComboOutput } from 'src/app/@shared/models/consulta-detalhe';
import { LoadArquivoService } from 'src/app/services/load-arquivo/load-arquivo.service';
import { ModalLoadArquivoComponent } from './modal-load/modal-load-arquivo.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalLoadArquivoService } from 'src/app/services/load-arquivo/modal-arquivo.service';

@Component({
  selector: 'app-load-arquivo',
  templateUrl: './load-arquivo.component.html',
  styleUrls: ['./load-arquivo.component.scss'],
})
export class LoadArquivoComponent implements OnInit, OnDestroy {
  consultaRelatorio: MatTableDataSource<any> = new MatTableDataSource<any>();
  isLoading: boolean;
  paging = { index: 0, size: 10, length: 0 };
  exibirGrid: boolean = false;
  public listaClientes: any[];
  public clientesFiltrados: ReplaySubject<ClienteComboOutput[]> =
    new ReplaySubject<ClienteComboOutput[]>(1);
  private onDestroy = new Subject<void>();
  dataSelecionada: any;
  periodoFinal: any;
  grid: any = null;
  gridFilter: {
    clienteID: any;
    periodoInicial: any;
    periodoFinal: any;
    itensPorPagina: number;
    paginaAtual: number;
  };
  clienteID: any;
  public clienteSelecionado: any;

  displayedColumns: string[] = [
    'operacao',
    'ipServidor',
    'pasta',
    'critica',
    'tipo_Arquivo',
    'nome_Tabela',
    'dtLoadDados',
    'usuLoadDados',
  ];

  Form = new FormGroup({
    periodoInicial: new FormControl(),
    periodoFinal: new FormControl(),
    clienteSelecionado: new FormControl(),
  });
  loadArquivo: any;
  config: any;
  dialog: MatDialog;
  get clienteIDSelecionado() {
    return this.Form.get('clienteSelecionado').value;
  }

  constructor(
    private loadArquivoService: LoadArquivoService,
    private snackBar: MatSnackBar,
    private svc: ModalLoadArquivoService,
    private dialogService: MatDialog
  ) {
    this.dialog = dialogService;
  }

  ngOnInit() {
    this.listaData()

    this.svc.getClientesAtivos().subscribe((res) => {
      if (res) {
        this.listaClientes = res;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
  
  listaData()
  { const filtroFim = new Date();
    const filtroInicio = new Date();
    filtroInicio.setDate(filtroInicio.getDate() - 30);
    this.Form.get('periodoInicial').setValue(filtroInicio);
    this.Form.get('periodoFinal').setValue(filtroFim);
    this.Form.updateValueAndValidity();
  }
  listarGrid() {
    this.isLoading = true;
    this.grid = null;
    this.gridFilter = {
      clienteID: this.clienteIDSelecionado,
      periodoInicial: this.Form.value.periodoInicial? this.Form.value.periodoInicial.toISOString().split('T')[0]: null,
      periodoFinal: this.Form.value.periodoFinal? this.Form.value.periodoFinal.toISOString().split('T')[0]: null,
      itensPorPagina: this.paging.size,
      paginaAtual: this.paging.index + 1,
    };

    this.loadArquivoService.loadArquivo(this.gridFilter).subscribe(
      (response: any[]) => {
        this.grid = response;
        this.exibirGrid = true;
        response.length ? (this.paging.length = response[0].totalCount) : null;
      },

      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(
          'Erro ao carregar listagem, entre em contato com o suporte: ' +
            (err.error.Protocolo ?? err.error.Message),
          'OK',
          10000,
          'danger-snackbar'
        );
      },
      () => (this.isLoading = false)
    );
  }

  selecionarCliente() {}

  onPageChange(evt: { pageIndex: number; pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.listarGrid();
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ) {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  openNovo() {
    this.dialog.open(ModalLoadArquivoComponent, {
      width: '800px',
    });
  }
  clearFields() {
    this.grid = null;
    this.Form.reset();
    this.periodoFinal = null;
  }
}
